import React, { FC } from 'react';
import { Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  visible: boolean;
  message: string;
}

const DocumentsSharingProgressModal: FC<Props> = (props) => {
  const { visible, message } = props;
  const { t } = useTranslation('contract');

  return (
    <Modal visible={visible} centered footer={null} width="auto">
      <Container>
        <Spin className="DocumentsSharingProgressModal-Spin" />
        <span className="DocumentsSharingProgressModal-Span">{t(message)}</span>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  display: flex;
  .DocumentsSharingProgressModal-Spin {
    display: flex;
    align-self: center;
  }
  .DocumentsSharingProgressModal-Span {
    margin-left: 10px;
    display: flex;
  }
`;

export default DocumentsSharingProgressModal;
